import React from 'react';
import { TreeSelect } from 'antd';
import FilterMatch from 'src/types/FilterMatch';
import Accordion from 'src/components/common/Accordion';
import useQueryUrlParams from 'src/hooks/useQueryUrlParams';
import useQueryUrlParamsDispatch from 'src/hooks/useQueryUrlParamsDispatch';
import { PRODUCT_DETAILS_ACTION_TYPES, ProductDetailsState } from 'src/stateProviders/productDetailsStateProvider';
import { useProductDetailsDispatchContext } from 'src/stateProviders/useProductDetailsStateContext';
import styles from './OwnerFilter.module.less';

type OwnerFilterProps = {
  loading: boolean;
  error: boolean;
  data: FilterMatch['owners'] | null;
};

const { TreeNode } = TreeSelect;

const OwnerFilter: React.FC<OwnerFilterProps> = ({ data, loading, error }) => {
  const setQuery = useQueryUrlParamsDispatch();
  const { owner } = useQueryUrlParams();
  const productDetailsDispatch = useProductDetailsDispatchContext();
  const handleChange = (key: string) => {
    setQuery({ owner: key });
    productDetailsDispatch({
      type: PRODUCT_DETAILS_ACTION_TYPES.setOwnerId,
      payload: { ownerId: key } as ProductDetailsState,
    });
  };

  return (
    <Accordion header={'Site'} loading={loading} error={error} errorTitle={'Site Filter'}>
      <div className={styles.ownerFilter}>
        {data && (
          <TreeSelect
            placeholder={'Select Site'}
            allowClear
            showSearch={true}
            treeDefaultExpandAll={false}
            treeCheckable={false}
            searchPlaceholder={'Search Site'}
            autoClearSearchValue
            treeIcon={false}
            treeCheckStrictly={false}
            onChange={handleChange}
            dropdownClassName={styles.treeSelect}
            defaultValue={owner}
          >
            {data.map(({ Id, label }) => (
              <TreeNode key={Id} value={Id.toString()} title={label} />
            ))}
          </TreeSelect>
        )}
      </div>
    </Accordion>
  );
};

export default OwnerFilter;
